export default function(state="De o zi", action) {

    switch(action.type) {
        
        case "ACTIVITY_TYPE":
            return action.payload;

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/ReducerActivityType.js